import ExpiryTimestamp from './ExpiryTimestamp';

export default ExpiryTimestamp;
